var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.mainLoading
        ? _c(
            "b-container",
            [
              _c(
                "b-row",
                _vm._l(_vm.providers, function (provider) {
                  return _c(
                    "b-col",
                    { key: provider.id, attrs: { cols: "12", sm: "3" } },
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            title: provider.name,
                            "img-top": "",
                            "img-alt": "Provider logo",
                          },
                        },
                        [
                          _vm.getSmtpSettings(provider.name)
                            ? _c("div", [
                                _c("p", [
                                  _c("strong", [_vm._v("Hostname:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getSmtpSettings(provider.name)
                                          .hostName
                                      )
                                  ),
                                ]),
                                _c("p", [
                                  _c("strong", [_vm._v("Port:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getSmtpSettings(provider.name)
                                          .portNumber
                                      )
                                  ),
                                ]),
                                _c("p", [
                                  _c("strong", [_vm._v("Username:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getSmtpSettings(provider.name)
                                          .username
                                      )
                                  ),
                                ]),
                                _c("p", [
                                  _c("strong", [_vm._v("Sender Email:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getSmtpSettings(provider.name)
                                          .senderEmail
                                      )
                                  ),
                                ]),
                                _c("p", [
                                  _c("strong", [_vm._v("SSL:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getSmtpSettings(provider.name)
                                          .enableSSL
                                          ? "Yes"
                                          : "No"
                                      )
                                  ),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-between",
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "secondary" },
                                        on: {
                                          click: function ($event) {
                                            _vm.showEditSmtpModal(
                                              _vm.getSmtpSettings(provider.name)
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Edit")]
                                    ),
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "danger" },
                                        on: {
                                          click: function ($event) {
                                            _vm.deleteSmtp(
                                              _vm.getSmtpSettings(provider.name)
                                                .id
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Delete")]
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _c(
                                "b-button",
                                {
                                  attrs: { variant: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showAddSmtpModal(provider.name)
                                    },
                                  },
                                },
                                [_vm._v("Add SMTP")]
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.mainLoading
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center" },
            [
              _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Spinning" },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          ref: "smtpModal",
          attrs: {
            id: "smtp-modal",
            title: "Add SMTP Configuration for " + _vm.selectedProvider,
            "hide-footer": "",
          },
          on: { ok: _vm.testSmtpConnection },
        },
        [
          _c(
            "validation-observer",
            { ref: "AddForm" },
            [
              _c(
                "b-form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submitSmtpForm($event)
                    },
                  },
                },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "SMTP Server Address:",
                        "label-for": "smtp-server",
                      },
                    },
                    [
                      _c("validation-provider", {
                        attrs: {
                          name: "SMTP Server Address",
                          vid: "SMTP Server Address",
                          rules: "required",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "smtp-server",
                                    required: "",
                                    placeholder: "Enter SMTP server address",
                                  },
                                  model: {
                                    value: _vm.smtpConfig.hostName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.smtpConfig, "hostName", $$v)
                                    },
                                    expression: "smtpConfig.hostName",
                                  },
                                }),
                                _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(errors[0])),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    { attrs: { label: "Port:", "label-for": "smtp-port" } },
                    [
                      _c("validation-provider", {
                        attrs: { name: "Port", vid: "Port", rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "smtp-port",
                                    required: "",
                                    type: "number",
                                    placeholder: "Enter SMTP port",
                                  },
                                  model: {
                                    value: _vm.smtpConfig.portNumber,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.smtpConfig,
                                        "portNumber",
                                        $$v
                                      )
                                    },
                                    expression: "smtpConfig.portNumber",
                                  },
                                }),
                                _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(errors[0])),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Username:",
                        "label-for": "smtp-username",
                      },
                    },
                    [
                      _c("validation-provider", {
                        attrs: {
                          name: "Username",
                          vid: "Username",
                          rules: "required",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "smtp-username",
                                    required: "",
                                    placeholder: "Enter SMTP username",
                                  },
                                  model: {
                                    value: _vm.smtpConfig.username,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.smtpConfig, "username", $$v)
                                    },
                                    expression: "smtpConfig.username",
                                  },
                                }),
                                _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(errors[0])),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Password:",
                        "label-for": "smtp-password",
                      },
                    },
                    [
                      _c("validation-provider", {
                        attrs: {
                          name: "Password",
                          vid: "Password",
                          rules: "required",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "smtp-password",
                                    required: "",
                                    type: "password",
                                    placeholder: "Enter SMTP password",
                                  },
                                  model: {
                                    value: _vm.smtpConfig.password,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.smtpConfig, "password", $$v)
                                    },
                                    expression: "smtpConfig.password",
                                  },
                                }),
                                _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(errors[0])),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: { label: "API Key:", "label-for": "smtp-apiKey" },
                    },
                    [
                      _c("validation-provider", {
                        attrs: { name: "apiKey", rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "smtp-apiKey",
                                    required: "",
                                    type: "text",
                                    placeholder: "Enter SMTP API Key",
                                  },
                                  model: {
                                    value: _vm.smtpConfig.apiKey,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.smtpConfig, "apiKey", $$v)
                                    },
                                    expression: "smtpConfig.apiKey",
                                  },
                                }),
                                _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(errors[0])),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    { attrs: { label: "Sender:", "label-for": "smtp-Sender" } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: { required: true, email_message: true },
                          name: "Sender Email",
                          vid: "Sender Email",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "smtp-Sender",
                                    placeholder: "Enter Sender Email",
                                  },
                                  model: {
                                    value: _vm.smtpConfig.senderEmail,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.smtpConfig,
                                        "senderEmail",
                                        $$v
                                      )
                                    },
                                    expression: "smtpConfig.senderEmail",
                                  },
                                }),
                                _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(errors[0])),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Recipient:",
                        "label-for": "smtp-recipient",
                      },
                    },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: { required: true, email_message: true },
                          name: "Recipient Email",
                          vid: "Recipient Email",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "smtp-recipient",
                                    placeholder: "Enter Recipient Email",
                                  },
                                  model: {
                                    value: _vm.smtpConfig.recipient,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.smtpConfig, "recipient", $$v)
                                    },
                                    expression: "smtpConfig.recipient",
                                  },
                                }),
                                _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(errors[0])),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-checkbox",
                    {
                      staticClass: "my-2",
                      model: {
                        value: _vm.smtpConfig.enableSSL,
                        callback: function ($$v) {
                          _vm.$set(_vm.smtpConfig, "enableSSL", $$v)
                        },
                        expression: "smtpConfig.enableSSL",
                      },
                    },
                    [_vm._v(" Use Encryption ")]
                  ),
                  _c(
                    "b-button",
                    {
                      attrs: { type: "button", variant: "success" },
                      on: { click: _vm.testSmtpConnection },
                    },
                    [_vm._v("Test Connection")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "Edit",
          attrs: {
            id: "smtp-edit-modal",
            title: "Edit SMTP Configuration for " + _vm.smtpConfigEdit.provider,
            "hide-footer": "",
          },
          on: { ok: _vm.testSmtpConnectionEdit },
        },
        [
          _c(
            "validation-observer",
            { ref: "EditForm" },
            [
              _c(
                "b-form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submitSmtpForm($event)
                    },
                  },
                },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "SMTP Server Address:",
                        "label-for": "smtp-server",
                      },
                    },
                    [
                      _c("validation-provider", {
                        attrs: {
                          name: "SMTP Server Address",
                          vid: "SMTP Server Address",
                          rules: "required",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "smtp-server",
                                    required: "",
                                    placeholder: "Enter SMTP server address",
                                  },
                                  model: {
                                    value: _vm.smtpConfigEdit.hostName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.smtpConfigEdit,
                                        "hostName",
                                        $$v
                                      )
                                    },
                                    expression: "smtpConfigEdit.hostName",
                                  },
                                }),
                                _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(errors[0])),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    { attrs: { label: "Port:", "label-for": "smtp-port" } },
                    [
                      _c("validation-provider", {
                        attrs: { name: "Port", vid: "Port", rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "smtp-port",
                                    required: "",
                                    type: "number",
                                    placeholder: "Enter SMTP port",
                                  },
                                  model: {
                                    value: _vm.smtpConfigEdit.portNumber,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.smtpConfigEdit,
                                        "portNumber",
                                        $$v
                                      )
                                    },
                                    expression: "smtpConfigEdit.portNumber",
                                  },
                                }),
                                _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(errors[0])),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Username:",
                        "label-for": "smtp-username",
                      },
                    },
                    [
                      _c("validation-provider", {
                        attrs: {
                          name: "Username",
                          vid: "Username",
                          rules: "required",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "smtp-username",
                                    required: "",
                                    placeholder: "Enter SMTP username",
                                  },
                                  model: {
                                    value: _vm.smtpConfigEdit.username,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.smtpConfigEdit,
                                        "username",
                                        $$v
                                      )
                                    },
                                    expression: "smtpConfigEdit.username",
                                  },
                                }),
                                _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(errors[0])),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Password:",
                        "label-for": "smtp-password",
                      },
                    },
                    [
                      _c("validation-provider", {
                        attrs: {
                          name: "Password",
                          vid: "Password",
                          rules: "required",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "smtp-password",
                                    required: "",
                                    type: "password",
                                    placeholder: "Enter SMTP password",
                                  },
                                  model: {
                                    value: _vm.smtpConfigEdit.password,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.smtpConfigEdit,
                                        "password",
                                        $$v
                                      )
                                    },
                                    expression: "smtpConfigEdit.password",
                                  },
                                }),
                                _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(errors[0])),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: { label: "API Key:", "label-for": "smtp-apiKey" },
                    },
                    [
                      _c("validation-provider", {
                        attrs: { name: "apiKey", rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "smtp-apiKey",
                                    required: "",
                                    type: "text",
                                    placeholder: "Enter SMTP API Key",
                                  },
                                  model: {
                                    value: _vm.smtpConfigEdit.apiKey,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.smtpConfigEdit,
                                        "apiKey",
                                        $$v
                                      )
                                    },
                                    expression: "smtpConfigEdit.apiKey",
                                  },
                                }),
                                _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(errors[0])),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    { attrs: { label: "Sender:", "label-for": "smtp-Sender" } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          name: "Sender Email",
                          vid: "Sender Email",
                          rules: "required",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "smtp-Sender",
                                    required: "",
                                    placeholder: "Enter Sender Email",
                                  },
                                  model: {
                                    value: _vm.smtpConfigEdit.senderEmail,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.smtpConfigEdit,
                                        "senderEmail",
                                        $$v
                                      )
                                    },
                                    expression: "smtpConfigEdit.senderEmail",
                                  },
                                }),
                                _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(errors[0])),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Recipient:",
                        "label-for": "smtp-recipient",
                      },
                    },
                    [
                      _c("validation-provider", {
                        attrs: {
                          name: "Recipient Email",
                          vid: "Recipient Email",
                          rules: "required|email",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "smtp-recipient",
                                    required: "",
                                    placeholder: "Enter Recipient Email",
                                  },
                                  model: {
                                    value: _vm.smtpConfigEdit.recipient,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.smtpConfigEdit,
                                        "recipient",
                                        $$v
                                      )
                                    },
                                    expression: "smtpConfigEdit.recipient",
                                  },
                                }),
                                _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(errors[0])),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-checkbox",
                    {
                      staticClass: "my-2",
                      model: {
                        value: _vm.smtpConfigEdit.enableSSL,
                        callback: function ($$v) {
                          _vm.$set(_vm.smtpConfigEdit, "enableSSL", $$v)
                        },
                        expression: "smtpConfigEdit.enableSSL",
                      },
                    },
                    [_vm._v(" Use Encryption ")]
                  ),
                  _c(
                    "b-button",
                    {
                      attrs: { type: "button", variant: "success" },
                      on: { click: _vm.testSmtpConnectionEdit },
                    },
                    [_vm._v("Test Connection")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }